import styled from "styled-components";

export const HR = styled.hr`
  border-top: 1px solid #e7e7e7;
  border-bottom: none;
`;
